<app-modal [dismissible]="true">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.strain.tickets.reports.modal.step3.gageConfiguration.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-strain-gage-configuration-form
            [isLoading]="isLoading"
            [showValidations]="showValidations"
            [measurementImage]="measurementImages"
            [gages]="gages">
        </app-strain-gage-configuration-form>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    (click)="close()">
            {{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    (click)="onSave()">
            {{ 'generic.buttons.save' | translate }}
        </app-button>
    </div>
</app-modal>
